/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useCallback, useEffect } from "react";
import { Routes, Route, Navigate, useNavigate, useLocation } from "react-router-dom";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import HomePage from "./pages/HomePage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import CreateEventPage from "./pages/CreateEventPage";
import EventPage from "./pages/EventPage";
import MyEventsPage from "./pages/MyEventsPage";
import AlarmsPage from "./pages/AlarmsPage";
import TimelinePage from "./pages/TimelinePage";
import ChartsPage from "./pages/ChartsPage";
import TemplatesPage from "./pages/TemplatesPage";
import InsightsPage from "./pages/InsightsPage";
import QuickActionsPage from "./pages/QuickActionsPage";
import SharedEventsPage from "./pages/SharedEventsPage";
import CreateSharedEventPage from "./pages/CreateSharedEventPage";
import SharedEventPage from "./pages/SharedEventPage";
import JoinEventPage from "./pages/JoinEventPage";
import "./App.css";
import "./glass-theme.css";

function App() {
  const token = localStorage.getItem("token");
  const navigate = useNavigate();
  const location = useLocation();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const toggleSidebar = useCallback((e) => {
    if (e) e.preventDefault();
    setSidebarOpen((prev) => !prev);
  }, []);

  const closeSidebar = useCallback(() => {
    setSidebarOpen(false);
  }, []);

  const navTo = useCallback((path) => (e) => {
    if (e) e.preventDefault();
    navigate(path);
    closeSidebar();
  }, [navigate, closeSidebar]);

  useEffect(() => {
    closeSidebar();
  }, [location.pathname, closeSidebar]);

  useEffect(() => {
    if (sidebarOpen) {
      document.body.classList.add("sidebar-hidden");
    } else {
      document.body.classList.remove("sidebar-hidden");
    }
  }, [sidebarOpen]);

  useEffect(() => {
    window.__toggleSidebar = toggleSidebar;
    return () => { delete window.__toggleSidebar; };
  }, [toggleSidebar]);

  const handleLogout = () => {
    localStorage.removeItem("token");
    navigate("/login");
    closeSidebar();
  };

  return (
    <div className="page-container">
      {sidebarOpen && (
        <div className="sidebar-overlay" onClick={closeSidebar} onTouchEnd={closeSidebar} />
      )}
      <div className="page-sidebar">
        <a className="logo" href="/" onClick={navTo("/")}>
          <img
            src={"/logo-kronix.png"}
            alt="Kronix Logo"
            style={{ maxWidth: "100%", padding: "0 40px" }}
          />
        </a>

        <ul className="list-unstyled accordion-menu">
          <li className="active-page">
            <a className="active">
              Activities
              <i className="fas fa-chevron-down dropdown-icon"></i>
            </a>
            <ul className="">
              <li>
                <a href="#" className="active" onClick={navTo("/my-events")}>
                  <i className="far fa-calendar-alt"></i>My Activities
                </a>
              </li>
              <li>
                <a href="#" className="active" onClick={navTo("/create-event")}>
                  <i className="far fa-calendar-plus"></i>Create Activity
                </a>
              </li>
              <li>
                <a href="#" className="active" onClick={navTo("/alarms")}>
                  <i className="fas fa-bell"></i>Default Alarms
                </a>
              </li>
              <li>
                <a href="#" className="active" onClick={navTo("/quick-actions")}>
                  <i className="fas fa-bolt"></i>Quick Actions
                </a>
              </li>
            </ul>
          </li>
          <li className="active-page">
            <a className="active">
              Events
              <i className="fas fa-chevron-down dropdown-icon"></i>
            </a>
            <ul className="">
              <li>
                <a href="#" className="active" onClick={navTo("/events")}>
                  <i className="fas fa-globe"></i>Browse Events
                </a>
              </li>
              <li>
                <a href="#" className="active" onClick={navTo("/create-shared-event")}>
                  <i className="fas fa-calendar-plus"></i>Create Event
                </a>
              </li>
            </ul>
          </li>
          <li className="active-page">
            <a className="active">
              Analytics
              <i className="fas fa-chevron-down dropdown-icon"></i>
            </a>
            <ul className="">
              <li>
                <a href="#" className="active" onClick={navTo("/timeline")}>
                  <i className="far fa-clock"></i>Timeline
                </a>
              </li>
              <li>
                <a href="#" className="active" onClick={navTo("/charts")}>
                  <i className="fas fa-chart-bar"></i>Charts
                </a>
              </li>
              <li>
                <a href="#" className="active" onClick={navTo("/insights")}>
                  <i className="fas fa-lightbulb"></i>Insights
                </a>
              </li>
            </ul>
          </li>
          <li className="active-page">
            <a className="active">
              Library
              <i className="fas fa-chevron-down dropdown-icon"></i>
            </a>
            <ul className="">
              <li>
                <a href="#" className="active" onClick={navTo("/templates")}>
                  <i className="fas fa-layer-group"></i>Templates
                </a>
              </li>
            </ul>
          </li>
          <li className="active-page">
            <a href="#" className="active">
              Account
              <i className="fas fa-chevron-down dropdown-icon"></i>
            </a>
            <ul className="">
              <li>
                <a href="#" className="active" onClick={navTo("/reset-password")}>
                  <i className="fas fa-key"></i>Reset Password
                </a>
              </li>
              <li>
                <a href="#" className="active" onClick={(e) => { e.preventDefault(); handleLogout(); }}>
                  <i className="fas fa-sign-out-alt"></i>Logout
                </a>
              </li>
            </ul>
          </li>
        </ul>
      </div>
      <div className="page-content">
        <Routes>
          <Route
            path="/"
            element={token ? <HomePage /> : <Navigate to="/login" />}
          />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route
            path="/reset-password"
            element={token ? <ResetPasswordPage /> : <Navigate to="/login" />}
          />
          <Route
            path="/create-event"
            element={token ? <CreateEventPage /> : <Navigate to="/login" />}
          />
          <Route
            path="/event/:id"
            element={token ? <EventPage /> : <Navigate to="/login" />}
          />
          <Route
            path="/event/:id/step2"
            element={token ? <CreateEventPage /> : <Navigate to="/login" />}
          />
          <Route
            path="/my-events"
            element={token ? <MyEventsPage /> : <Navigate to="/login" />}
          />
          <Route
            path="/alarms"
            element={token ? <AlarmsPage /> : <Navigate to="/login" />}
          />
          <Route
            path="/timeline"
            element={token ? <TimelinePage /> : <Navigate to="/login" />}
          />
          <Route
            path="/charts"
            element={token ? <ChartsPage /> : <Navigate to="/login" />}
          />
          <Route
            path="/templates"
            element={token ? <TemplatesPage /> : <Navigate to="/login" />}
          />
          <Route
            path="/insights"
            element={token ? <InsightsPage /> : <Navigate to="/login" />}
          />
          <Route
            path="/quick-actions"
            element={token ? <QuickActionsPage /> : <Navigate to="/login" />}
          />
          <Route
            path="/events"
            element={token ? <SharedEventsPage /> : <Navigate to="/login" />}
          />
          <Route
            path="/create-shared-event"
            element={token ? <CreateSharedEventPage /> : <Navigate to="/login" />}
          />
          <Route
            path="/shared-event/:id"
            element={token ? <SharedEventPage /> : <Navigate to="/login" />}
          />
          <Route
            path="/join/:code"
            element={<JoinEventPage />}
          />
        </Routes>
      </div>
    </div>
  );
}

export default App;
